import { useSetAtom } from 'jotai';

import pdpSelectedProtectionPlanIdAtom from './pdpSelectedProtectionPlanIdAtom';

const useSetPdpSelectedProtectionPlanId = () => {
  const setPdpSelectedProtectionPlanId = useSetAtom(
    pdpSelectedProtectionPlanIdAtom
  );

  return setPdpSelectedProtectionPlanId;
};

export default useSetPdpSelectedProtectionPlanId;
